import { render, staticRenderFns } from "./customerSelector.vue?vue&type=template&id=e801173a"
import script from "./customerSelector.vue?vue&type=script&lang=js"
export * from "./customerSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports